import { render, staticRenderFns } from "./TopBarMenu.vue?vue&type=template&id=499abcdd&scoped=true"
import script from "./TopBarMenu.vue?vue&type=script&lang=js"
export * from "./TopBarMenu.vue?vue&type=script&lang=js"
import style0 from "./TopBarMenu.vue?vue&type=style&index=0&id=499abcdd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499abcdd",
  null
  
)

export default component.exports